var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "route route-container" }, [
    _c("div", { staticClass: "stop route-stop--sender" }, [
      _c("span", { staticClass: "label" }, [
        _c("span", { staticClass: "dot" }),
        _vm._v(" " + _vm._s(_vm.$t("trajectory.senderInfo")) + " "),
      ]),
      _c("span", { staticClass: "main stop-main" }, [
        _vm._v(_vm._s(_vm.senderLocationText)),
      ]),
      _c("span", { staticClass: "sub stop-sub" }, [
        _vm._v(
          _vm._s(_vm.$t("trajectory.zipCode")) +
            " " +
            _vm._s(_vm.senderZipcode || "--")
        ),
      ]),
    ]),
    _c("div", { staticClass: "mid route-mid" }, [
      _c("span", { staticClass: "truck truck-icon", style: _vm.truckStyle }, [
        _c(
          "svg",
          {
            attrs: {
              fill: "none",
              height: "18",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "1.4",
              viewBox: "0 0 22 22",
              width: "18",
            },
          },
          [
            _c("path", {
              attrs: { d: "M2 15V7a1 1 0 0 1 1-1h9v9M12 9h4l3 3v3h-2.5" },
            }),
            _c("circle", { attrs: { cx: "6.5", cy: "16", r: "1.6" } }),
            _c("circle", { attrs: { cx: "15.5", cy: "16", r: "1.6" } }),
            _c("path", { attrs: { d: "M8.1 16h5.8M2 16h2.9" } }),
          ]
        ),
      ]),
      _c(
        "span",
        { staticClass: "status status-text", style: _vm.statusStyle },
        [_vm._v(_vm._s(_vm.currentStatusText))]
      ),
    ]),
    _c(
      "div",
      {
        staticClass: "stop route-stop--receiver",
        staticStyle: { "text-align": "right" },
      },
      [
        _c(
          "span",
          {
            staticClass: "label",
            staticStyle: { "justify-content": "flex-end" },
          },
          [
            _c("span", { staticClass: "dot" }),
            _vm._v(" " + _vm._s(_vm.$t("trajectory.receiverInfo")) + " "),
          ]
        ),
        _c("span", { staticClass: "main stop-main" }, [
          _vm._v(_vm._s(_vm.receiverLocationText)),
        ]),
        _c("span", { staticClass: "sub stop-sub" }, [
          _vm._v(
            _vm._s(_vm.$t("trajectory.zipCode")) +
              " " +
              _vm._s(_vm.receiverZipcode || "--")
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }